export const purposesLoadingSpinner = {
  regular: 'transition-between-pages',
  additional: 'when-loading-response',
};
